var map = {
	"./back-btn.png": "./src/images/back-btn.png",
	"./bannercir.png": "./src/images/bannercir.png",
	"./calendar.svg": "./src/images/calendar.svg",
	"./diary-logo.png": "./src/images/diary-logo.png",
	"./down-arrow.png": "./src/images/down-arrow.png",
	"./pdf.svg": "./src/images/pdf.svg",
	"./sky-bg.png": "./src/images/sky-bg.png",
	"./swiper-next-grey.png": "./src/images/swiper-next-grey.png",
	"./swiper-next.png": "./src/images/swiper-next.png",
	"./swiper-prev-grey.png": "./src/images/swiper-prev-grey.png",
	"./swiper-prev.png": "./src/images/swiper-prev.png",
	"./video-shadow.png": "./src/images/video-shadow.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images sync \\.(png|jpe?g|svg)$";